/**
 * List of email templates to be used in Sending Blue.
 */
export const EmailTemplates = {
  InvoiceBoipaCollect: 104,
  InvoiceBilling: 174,
  PoSystemOrder: 107,
  PoSystemOrderToSupplier: 159,
  EdiOrderConfirmationDiscrepancies: 121,
  PaidBillingInvoice: 142,
  PieCloudCreatePassword: 109,
  StaffInvitationCretePassword: 151,
  GiftCardCreatePassword: 71,
  AutomaticPhysicalCardsProcessingError: 171,
  StaffCard: 91,
  SupersweetCreatePassword: 177,
  SupersweetResetPassword: 181,
  SupersweetVerifyYourBusiness: 179,
  SupersweetBusinessVerificationComplete: 180,
} as const;
